// extracted by mini-css-extract-plugin
module.exports = {"upload-btn-active":"_30Iwvdx3nmj4sDsmweTUZB","upload-btn-disabled":"_1qzuJllo_Yayx5P5G_QoOk"};